import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";

/**
 * Single WIM Blog article card. Used on the WIM Blog index and in the
 * Related Articles section of an article page — same component, same look.
 *
 * Compact by design (Aug 2026): a restrained 16:9 thumbnail — not a large
 * hero block — so the headline and excerpt stay the visual focus as more
 * articles are added. When an article has no featured image, the image
 * area is omitted entirely rather than showing an empty placeholder.
 */
export default function WimArticleCard({ post, testIdPrefix = "blog-card" }) {
  return (
    <Link
      to={`/wim/${post.slug}`}
      className="card-base overflow-hidden flex flex-col group"
      data-testid={`${testIdPrefix}-${post.slug}`}
    >
      {post.featured_image && (
        <div className="aspect-[16/9] overflow-hidden">
          <img src={post.featured_image} alt="" className="w-full h-full object-cover" />
        </div>
      )}
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center justify-between gap-3 mb-3">
          <span className="pill bg-slate-100 text-ink-muted">{post.category}</span>
          {post.read_minutes ? (
            <span className="text-xs text-ink-soft flex items-center gap-1">
              <Clock className="w-3.5 h-3.5" /> {post.read_minutes} min read
            </span>
          ) : null}
        </div>
        <h3 className="font-display text-xl font-semibold leading-snug group-hover:text-teal transition-colors">
          {post.title}
        </h3>
        <p className="mt-2 text-ink-muted text-sm flex-1">{post.excerpt}</p>
        <div className="mt-4 flex items-center gap-1 text-teal font-medium text-sm">
          Read More <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </Link>
  );
}
